import api from './api'

const activityService = {
  // Get all activities
  getAllActivities: async (params = {}) => {
    const response = await api.get('/activities', { params })
    return response.data
  },

  // Get activity by ID
  getActivityById: async (id) => {
    const response = await api.get(`/activities/${id}`)
    return response.data
  },

  // Create activity (admin)
  createActivity: async (activityData) => {
    const response = await api.post('/activities', activityData)
    return response.data
  },

  // Update activity (admin)
  updateActivity: async (id, activityData) => {
    const response = await api.put(`/activities/${id}`, activityData)
    return response.data
  },

  // Delete activity (admin)
  deleteActivity: async (id) => {
    const response = await api.delete(`/activities/${id}`)
    return response.data
  },
}

export default activityService
